export default __webpack_public_path__ + "static/media/ally.8e386dfa.png";